<template>
  <div class="notification-layout">
    <div class="content">
      <div class="notification-back">
        <svg @click="emit('closenotification')" width="10" height="14" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m1.17 5.29 4.24-4.24a1 1 0 1 1 1.42 1.41L3.29 6l3.54 3.54a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29L1.17 6.71a1 1 0 0 1 0-1.42z" fill="#21409A"/>
        </svg>
        <span @click="emit('closenotification')">Notifikasi</span>
      </div>
      <NotificationContent />
    </div>
  </div>
</template>

<script setup>
import { defineEmit, watch } from 'vue'
import { useRoute } from 'vue-router'
import NotificationContent from '../Notification/NotificationContent.vue'

// const bodyEl = document.getElementsByTagName('body')[0]
const emit = defineEmit()

const route = useRoute()

watch(route, () => {
  emit('closenotification')
}, { deep: true })

// onMounted(() => {
//   const bodyEl = document.getElementsByTagName('body')[0]
//   bodyEl.style.overflow = 'hidden'
// })
// onUnmounted(() => {
//   const bodyEl = document.getElementsByTagName('body')[0]
//   bodyEl.style.overflow = 'scroll'
// })

</script>

<style lang="scss" scoped>
  .notification-layout {
    overflow: hidden;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100%;
    z-index: 999;

    .content {
      position: static;
      // padding: .65em;
      display: flex;
      flex-direction: column;
      .notification-back {
        justify-content: flex-start;
        padding: .6em;

        svg {
          align-self: center;
          font-size: 20px;
          padding-top: .1em;
        }

        span {
          font-weight: 500;
          color: $blue;
          margin-left: .3em;
          font-size: 16px;
          align-self: center;
        }
      }
    }

  }

  .no-scroll {
    overflow: hidden;
  }
</style>
